import { mapMarketRates } from 'app/pages/tpoPortal/commandCenterHome/CommandCenterHome/marketRates.utils';
import { marketRatesApi } from 'app/services/api';

import { catchAsyncActionError } from 'utils/action';
import { createNamedActions } from 'utils/namedActionTypesProxy';

// Broker-facing reads — a 403 (DEV-3647 broker-auth gap) must degrade to the
// empty state, never trigger the global forbidden page-reload loop. PMMS is the
// public benchmark; the rate sheet is company-scoped from the JWT.
const SKIP_FORBIDDEN_CONFIG = { skipResponseInterceptor: { forbiddenError: true } };

const PMMS_WEEKS = 6;

export const COMMAND_CENTER_MARKET_RATES_ACTION_TYPE = createNamedActions(
  'commandCenterMarketRates',
  {
    SET_MARKET_RATES: 'SET_MARKET_RATES',
  },
);

export const getMarketRatesAction = catchAsyncActionError(() => async dispatch => {
  const [{ data: pmms }, { data: rateSheet }] = await Promise.all([
    marketRatesApi.getRecentPmms({ weeks: PMMS_WEEKS, config: SKIP_FORBIDDEN_CONFIG }),
    marketRatesApi.getLatestRateSheet({ config: SKIP_FORBIDDEN_CONFIG }),
  ]);

  return dispatch({
    type: COMMAND_CENTER_MARKET_RATES_ACTION_TYPE.SET_MARKET_RATES,
    payload: mapMarketRates({ pmms: pmms ?? null, rateSheet: rateSheet ?? null }),
  });
});
